<template>
  <div class="modal-wrap">
    <el-dialog
      :title="editId ? '编辑需求' : '新增需求'"
      @open="initSelect"
      :visible.sync="dialogVisible"
      width="780px"
      :close-on-click-modal="false"
      @closed="modalClosed"
    >
      <div class="form-wrap">
        <el-form label-width="130px" :model="formData" :rules="rules" ref="tableRef">
          <el-row v-for="(child, index) in formData.materials" :key="index" class="basic">
            <div style="display: flex">
              <el-form-item
                label="玩法名称："
                :prop="'materials.' + index + '.afid'"
                :rules="{
                  required: true,
                  message: '玩法名称不能为空',
                  trigger: ['blur', 'change'],
                }"
              >
                <el-select class="select-item" v-model="child.afid" filterable placeholder="请选择玩法名称">
                  <el-option v-for="item in productList" :key="item.id" :label="item.playName" :value="item.afid"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="制作类型："
                :prop="'materials.' + index + '.productionType'"
                :rules="{
                  required: true,
                  message: '制作类型不能为空',
                  trigger: ['blur', 'change'],
                }"
              >
                <el-select class="select-item" v-model="child.productionType" filterable multiple placeholder="请选择制作类型">
                  <el-option v-for="item of productionTypeList" :label="item.label" :value="item.value" :key="item.value"> </el-option>
                  <el-option label="其他" value="other"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                class="otherText"
                :prop="'materials.' + index + '.otherText'"
                label=""
                v-if="(child.productionType || []).includes('other')"
                :rules="{
                  required: true,
                  message: '制作类型不能为空',
                  trigger: ['blur', 'change'],
                }"
              >
                <el-input v-model="child.otherText" placeholder="请输入制作类型"></el-input>
              </el-form-item>
            </div>
            <div class="remark">素材需求具体内容：</div>
            <el-form-item
              label=""
              :prop="'materials.' + index + '.materialRemark'"
              class="remark-input"
              :rules="{
                required: true,
                message: '素材需求具体内容不能为空',
                trigger: ['blur', 'change'],
              }"
            >
              <el-input class="input-area" type="textarea" :rows="3" placeholder="请输入" v-model="child.materialRemark" resize="none">
              </el-input>
            </el-form-item>
            <svg-icon v-if="index > 0" @click="deleteCondition(child, index)" iconClass="close" className="close-icon"></svg-icon>
          </el-row>
          <div class="add-condition" v-if="!this.editId" @click="addCondition"><i class="el-icon-plus"></i>增加条件</div>
          <div style="display: flex">
            <div class="left">
              <el-form-item label="创意来源：" prop="creativeSource">
                <el-select class="select-item" v-model="formData.creativeSource" filterable placeholder="请选择创意来源">
                  <el-option label="竞品素材" value="竞品素材"> </el-option>
                  <el-option label="投放设计" value="投放设计"> </el-option>
                  <el-option label="视频自制" value="视频自制"> </el-option>
                  <el-option label="策划" value="策划"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="语言：" prop="lang">
                <el-select class="select-item" v-model="formData.lang" @change="changeLang" filterable multiple placeholder="请选择语言">
                  <el-option label="无语言" value="-"> </el-option>
                  <el-option v-for="item of langList" :label="item.label" :value="item.value" :key="item.value"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="素材类型：" prop="materialType">
                <el-select class="select-item" v-model="formData.materialType" filterable placeholder="请选择素材类型">
                  <el-option label="视频" value="视频"> </el-option>
                  <el-option label="gif" value="gif"> </el-option>
                  <el-option label="psd" value="psd"> </el-option>
                  <el-option label="图片" value="图片"> </el-option>
                  <el-option label="playable" value="playable"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="素材设计人员：" prop="materialDesigner">
                <el-select class="select-item" v-model="formData.materialDesigner" placeholder="请选择素材设计人员" filterable allow-create>
                  <el-option v-for="(item, index) in principalNameList" :key="index" :label="item" :value="item"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="素材制作人员：" prop="materialProductor">
                <el-select class="select-item" v-model="formData.materialProductor" filterable placeholder="请选择素材制作人员">
                  <el-option v-for="item of productorList" :key="item" :label="item" :value="item"> </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="right" style="width: 370px">
              <el-form-item label="需求截止时间：" prop="deadline">
                <el-date-picker
                  class="select-date"
                  v-model="formData.deadline"
                  type="date"
                  placeholder="原则上三天内"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  :clearable="false"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="个数：" prop="materialCount">
                <el-input disabled v-model="formData.materialCount" placeholder="请输入个数" type="number"></el-input>
              </el-form-item>
              <el-form-item label="尺寸：" prop="size">
                <ul class="size-list">
                  <li class="size-item" v-for="item of formData.size" :key="item.id">
                    <el-input
                      onkeyup="value=value.replace(/[^\d]/g,'')"
                      class="input-num"
                      placeholder="数量"
                      maxlength="6"
                      v-model="item.num"
                    ></el-input>
                    <el-input
                      class="input-size"
                      placeholder="宽度"
                      v-model="item.width"
                      maxlength="6"
                      onkeyup="value=value.replace(/[^\d]/g,'')"
                    ></el-input>
                    <span class="center-icon">*</span>
                    <el-input
                      class="input-size"
                      placeholder="高度"
                      maxlength="6"
                      v-model="item.height"
                      onkeyup="value=value.replace(/[^\d]/g,'')"
                    ></el-input>
                    <svg-icon @click="deleteSize(item.id)" iconClass="delete" className="del-icon"></svg-icon>
                  </li>
                  <div class="add-btn">
                    <el-select class="size-select" v-model="sizeType" placeholder="" @change="changeSizeType">
                      <el-option v-for="item in defaultSizeList" :key="item.id" :label="item.size" :value="item.id"> </el-option>
                    </el-select>
                    <div class="btn-text"><i class="el-icon-plus"></i>添加</div>
                  </div>
                </ul>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="loading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
import { addMatreial, modifyMaterial, geMaterialSizeList, getDesigner } from "@/api/materialManage.js";
import { langList, productionTypeList } from "../../confData.js";
export default {
  name: "EditModal",
  props: {
    productList: Array,
    productorList: Array,
  },
  components: {
    SvgIcon,
  },
  watch: {
    "formData.size": {
      handler(val) {
        let sum = 0;
        val.forEach((item) => {
          sum += Number(item.num) || 0;
        });
        this.formData.materialCount = sum;
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      defaultSizeList: [],
      dialogVisible: false,
      editId: null,
      formData: {
        materials: [{ afid: null, productionType: [], materialRemark: "" }],
        creativeSource: null,
        lang: [],
        materialType: null,
        materialCount: 0,
        deadline: null,
        materialDesigner: "",
        materialProductor: null,
        size: [],
      },
      loading: false,
      rules: {
        creativeSource: [
          {
            required: true,
            message: "请选择创意来源",
            trigger: ["blur", "change"],
          },
        ],
        lang: [
          {
            required: true,
            message: "请选择语言",
            trigger: ["blur"],
          },
        ],
        materialType: [
          {
            required: true,
            message: "请选择素材类型",
            trigger: ["blur", "change"],
          },
        ],
        materialCount: [
          {
            required: true,
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (value === null || value === "") {
                callback(new Error("素材个数必填"));
              } else if (parseInt(value) <= 0) {
                callback(new Error("素材个数不规范"));
              } else {
                callback();
              }
            },
          },
        ],
        size: [
          {
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              let total = 0;
              value.forEach((item) => {
                total += parseInt(item.num);
              });
              let errorItem = value.find((item) => {
                return (
                  item.num === "" ||
                  item.width === "" ||
                  item.height === "" ||
                  parseInt(item.num) <= 0 ||
                  parseInt(item.width) <= 0 ||
                  parseInt(item.height) <= 0
                );
              });
              if (errorItem) {
                callback(new Error("部分数据填写不规范"));
              } else if (this.formData.materialCount !== "" && total !== parseInt(this.formData.materialCount)) {
                callback(new Error("个数与尺寸数据不一致"));
              } else {
                callback();
              }
            },
          },
        ],
        deadline: [
          {
            required: true,
            message: "请选择需求截止时间",
            trigger: ["blur", "change"],
          },
        ],
        materialDesigner: [
          {
            required: true,
            message: "请输入素材设计人员",
            trigger: ["blur", "change"],
          },
        ],
        materialProductor: [
          {
            required: true,
            message: "请选择素材制作人员",
            trigger: ["blur", "change"],
          },
        ],
      },
      langList: langList,
      productionTypeList: productionTypeList,
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 604800000;
        },
      },
      sizeType: null,
      principalNameList: [],
    };
  },
  methods: {
    initSelect() {
      //投放负责人
      getDesigner().then((res) => {
        this.principalNameList = res.designer;
      });
      geMaterialSizeList().then((res) => {
        if (res.code === "0000") {
          this.defaultSizeList = res.data.map((item) => {
            item.width = item.size.split("*")[0];
            item.height = item.size.split("*")[1];
            return item;
          });
          this.defaultSizeList.push({
            size: "自定义",
            id: 0,
            with: "",
            height: "",
          });
        }
      });
    },
    changeLang(val) {
      const index = val?.indexOf("-");
      if (index > 0) {
        this.formData.lang = ["-"];
      } else if (index === 0 && val.length > 1) {
        this.formData.lang.shift();
      }
    },
    editData(data, mode) {
      if (!data) {
        this.editId = null;
        this.formData.materials = [{ afid: null, productionType: [], materialRemark: "" }];
        this.formData.creativeSource = null;
        this.formData.lang = null;
        this.formData.materialType = null;
        this.formData.materialCount = 0;
        this.formData.deadline = null;
        this.formData.materialDesigner = "";
        this.formData.materialProductor = null;
        this.formData.size = [];
      } else {
        const {
          afId,
          productionType,
          materialRemark,
          creativeSource,
          deadline,
          materialCount,
          materialType,
          materialDesigner,
          materialProductor,
          size,
        } = data;
        let otherText = "";
        let productionTypeNameList = [];
        productionType.split(",").forEach((item) => {
          const isOther = !this.productionTypeList.find((child) => child.value === item);
          if (isOther) {
            otherText = item;
            productionTypeNameList.push("other");
          } else {
            productionTypeNameList.push(item);
          }
        });
        this.formData.materials = this.formData.materials.slice(0, 1);
        this.formData.materials[0].materialRemark = materialRemark;
        this.formData.materials[0].afid = afId;
        this.formData.materials[0].productionType = productionTypeNameList;
        this.$set(this.formData.materials[0], "otherText", otherText);
        this.formData.creativeSource = creativeSource;
        this.formData.deadline = deadline;
        this.formData.lang = data.lang ? data.lang.split(",") : ["-"];
        this.formData.materialCount = materialCount;
        this.formData.materialType = materialType;
        this.formData.materialDesigner = materialDesigner;
        this.formData.materialProductor = materialProductor;
        this.formData.size = JSON.parse(size);
        this.editId = data.id;
        if (mode === "copy") {
          this.editId = "";
        }
      }
      this.dialogVisible = true;
    },
    deleteSize(id) {
      let delIndex = this.formData.size.findIndex((item) => item.id === id);
      if (delIndex !== -1) {
        this.formData.size.splice(delIndex, 1);
      }
    },
    modalClosed() {
      this.$nextTick(() => {
        this.$refs.tableRef.resetFields();
      });
    },
    addCondition() {
      this.formData.materials.push({
        afid: null,
        productionType: [],
        materialRemark: "",
      });
    },
    deleteCondition(data, index) {
      this.formData.materials.splice(index, 1);
    },
    changeSizeType(value) {
      this.sizeType = null;
      // 默认尺寸
      if (value === 0) {
        this.formData.size.push({
          id: Math.random(),
          num: "",
          width: "",
          height: "",
        });
      } else {
        const sizeItem = this.defaultSizeList.find((item) => item.id === value);
        this.formData.size.push({
          id: Math.random(),
          num: "",
          width: sizeItem.width,
          height: sizeItem.height,
        });
      }
    },
    saveData() {
      this.$refs.tableRef.validate((valid) => {
        if (valid) {
          let copyData = JSON.parse(JSON.stringify(this.formData));
          copyData.size = JSON.stringify(copyData.size);
          copyData.materials.map((item) => {
            item.appName = this.productList.find((child) => child.afid === item.afid).playName;
            // 判断是否存在other
            const otherIndex = item.productionType.indexOf("other");
            if (otherIndex > -1) {
              item.productionType.splice(otherIndex, 1, item.otherText);
              delete item.otherText;
            }
            item.productionType = item.productionType.join(",");
            return item;
          });
          //语言
          if (copyData.lang.includes("-")) {
            delete copyData.lang;
          } else {
            copyData.lang = copyData.lang.join(",");
          }
          delete copyData.createTime; //避免修改创建时间
          this.loading = true;
          if (this.editId) {
            copyData.id = this.editId;
            modifyMaterial(copyData).then((res) => {
              this.loading = false;
              if (res.code === "0000") {
                this.$message({
                  message: "需求修改成功",
                  type: "success",
                });
                this.dialogVisible = false;
                this.$emit("refresh", true);
              }
            });
          } else {
            addMatreial(copyData).then((res) => {
              this.loading = false;
              if (res.code === "0000") {
                this.$message({
                  message: "新增需求成功",
                  type: "success",
                });
                this.dialogVisible = false;
                this.$emit("refresh", true);
              }
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.modal-wrap {
  .form-wrap {
    height: 442px;
    overflow: auto;
    padding-right: 6px;
    /deep/ .el-form-item__label {
      padding: 0 4px 0 0;
    }
    /deep/ .el-input__inner {
      padding: 0px 0px 0px 15px;
    }
    .select-item {
      width: 100%;
    }
    .input-area {
      /deep/ .el-textarea__inner {
        height: 104px;
      }
    }
    .select-date {
      width: 100%;
      /deep/ .el-input__prefix {
        left: 214px;
      }
    }
    .basic {
      padding: 16px 16px 0 0;
      border-radius: 4px;
      width: 636px;
      margin-left: 50px;
      background: rgba(244, 244, 244, 1);
      margin-bottom: 16px;
      margin-top: 14px;
      position: relative;

      /deep/ .el-form-item__label {
        width: 90px !important;
      }
      /deep/ .el-form-item__content {
        margin-left: 90px !important;
      }
      .remark-input {
        /deep/ .el-form-item__content {
          margin-left: 16px !important;
        }
      }
      .remark {
        color: rgba(0, 0, 0, 0.65);
        padding-left: 16px;
        margin-bottom: 4px;
      }
      .close-icon {
        width: 14px;
        background: #d6d6d6;
        height: 14px;
        border-radius: 50%;
        padding: 4px;
        position: absolute;
        top: -12px;
        right: -7px;
      }
      .otherText {
        /deep/ .el-form-item__content {
          margin-left: 20px !important;
        }
      }
    }
    .add-condition {
      height: 34px;
      width: 636px;
      margin-left: 50px;
      border-radius: 2px;
      border: 1px solid rgba(97, 179, 255, 1);
      box-sizing: border-box;
      background: rgba(255, 255, 255, 1);
      line-height: 34px;
      text-align: center;
      color: rgb(24, 144, 255);
      margin-bottom: 30px;
      cursor: pointer;
    }
    .size-list {
      padding: 0px;
      margin: 0px;
      list-style: none;
      .size-item {
        display: flex;
        position: relative;
        .input-num {
          border-radius: 0px;
          width: 60px;
          line-height: 30px;
          height: 30px;
          margin-right: 4px;
        }
        .center-icon {
          display: inline-block;
          margin: 0 5px;
        }
        .input-size {
          width: 70px;
          border-radius: 0px;
          position: relative;
          right: 1px;
          line-height: 30px;
          height: 30px;
        }
        .del-icon {
          position: absolute;
          top: 8px;
          right: -18px;
          font-size: 16px;
          cursor: pointer;
        }
      }
      .add-btn {
        position: relative;
        height: 55px;
        width: 100%;
        .size-select {
          position: absolute;
          top: 0px;
          left: 0px;
          z-index: 9;
          width: 100%;
          /deep/ .el-icon-arrow-up:before {
            content: none;
          }
          /deep/ .el-input__inner {
            background: rgba(0, 0, 0, 0.02);
            text-align: center;
            color: #1890ff !important;
          }
        }
        .btn-text {
          color: rgba(24, 144, 255, 1);
          font-size: 12px;
          position: absolute;
          top: 1px;
          left: 92px;
        }
      }
    }
  }
  .form-wrap::-webkit-scrollbar {
    width: 4px;
  }
  .form-wrap::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }
  // .form-wrap::-webkit-scrollbar-track {
  //   -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  //   border-radius: 0;
  //   background: rgba(0, 0, 0, 0);
  // }
}
</style>
